import { Editor } from '@tinymce/tinymce-react';
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { convertUtcToUserTimezone } from '../../../utils/helpers';

import CRMApi from 'Api/CRM/CRMApi';
import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

class SingleNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: {},
            languages: [],
            translations: [],
            news_categories: [],
        };
    }

    componentDidMount() {
        CRMApi.get('languages').then((response) => {
            this.setState({ languages: response.data });
        });
        CRMApi.get('news/translations').then((response) => {
            this.setState({ translations: response.data });
        });
        CRMApi.get('news_category').then((response) => {
            this.setState({ news_categories: response.data.data });
        });
        // eslint-disable-next-line react/destructuring-assignment
        const newsId = this.props.match.params.id;
        CRMApi.get(`news/${newsId}`).then((response) => {
            this.setState({ news: response.data });
        });
    }

    render() {
        const { languages, translations, news, news_categories: newsCategories } = this.state;
        return (
            <Card title="News details">
                <TableDetailsBody>
                    <Row label="Title">{news.title}</Row>
                    <Row label="Slug">{news.slug}</Row>
                    <Row label="Language" showIf={!!languages.length}>
                        {languages.filter((lang) => lang.id === news.language_id)[0]?.name}
                    </Row>
                    <Row label="This is translation of" showIf={!!translations.length}>
                        {translations.filter((translation) => translation.id === news.translation_id)[0]?.title}
                    </Row>
                    <Row label="News category" showIf={!!newsCategories.length}>
                        {newsCategories.filter((category) => category.id === news.news_category_id)[0]?.name}
                    </Row>
                    <Row label="Short text">{news.short_text}</Row>
                    <Row label="Text">
                        <Editor id="text" name="text" init={{ height: 400 }} value={news.text} disabled />
                    </Row>
                    <Row label="Publication date">
                        {news.publication_date ? convertUtcToUserTimezone(news.publication_date) : ''}
                    </Row>
                </TableDetailsBody>
                <Link to={`/news/${news.id}/edit`} className="btn btn-default">
                    Edit News
                </Link>
            </Card>
        );
    }
}

export default withRouter(SingleNews);
